import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NzTableModule} from "ng-zorro-antd/table";
import {SessionService, User} from "../@core/session.service";

@Component({
  selector: 'app-person',
  standalone: true,
  imports: [CommonModule, NzTableModule],
  template: `
      <ng-container *ngIf="user">
          <ng-template #header>
              <strong>Personal Information</strong>
          </ng-template>
          <nz-table [nzTitle]="header" nzTemplateMode="true" nzBordered="true" nzSize="small">
              <tbody>
              <tr>
                  <ng-container *ngIf="user.origin === 'ADMS'; else aims">
                      <td>Application No.</td>
                      <td>{{user.ext_id}}</td>
                  </ng-container>
                  <ng-template #aims>
                      <td>Student No.</td>
                      <td>{{user.stud_no}}</td>
                  </ng-template>
                  <td>Email Address</td>
                  <td>{{user.email}}</td>
              </tr>
              <tr>
                  <td>Name</td>
                  <td>{{user.stud_name}}</td>
                  <td>Gender</td>
                  <td>{{user.gender}}</td>
              </tr>
              </tbody>
          </nz-table>
      </ng-container>
  `,
  styles: []
})
export class PersonComponent {
  user!: User;

  constructor(private sess: SessionService) {
    this.user = sess.user!;
  }
}
